import moment from "moment";
import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { toast } from "react-toastify";
import { Card, Form, Button, Table } from "tabler-react";
import { getBlockUsersToDb, unblockCustomer } from "../../services/client";

function ViewBlockedUsers({ refreshData }) {
    const [optinData, setOptinData] = useState([]);

    const getData = async () => {
        try {
            let res = await getBlockUsersToDb();
            if (res.data && res.data.length) setOptinData(res.data);
        } catch (error) {
            console.error(error);
        }
    };

    const handleUnblock = async (obj) => {
        try {
            let { data: res } = await unblockCustomer(obj._id);
            if (res) {

                toast.success(res.message)
            }
        } catch (error) {
            console.error(error);
            toast.error("Something went wrong");
        }
    }

    useEffect(
        () => {
            getData();
        },
        [refreshData]
    );

    return (
        <Card>
            <Card.Header>
                <Card.Title>Blocked Customers</Card.Title>
            </Card.Header>
            <Card.Body>
                <Table cards={true} striped={true} responsive={true} className="table-vcenter ">
                    <Table.Header>
                        <Table.Row>
                            <Table.ColHeader>Sno.</Table.ColHeader>
                            <Table.ColHeader>Mobile Number</Table.ColHeader>
                            {/* <Table.ColHeader>File Name</Table.ColHeader> */}
                            {/* <Table.ColHeader>Download File</Table.ColHeader> */}
                            <Table.ColHeader>Action</Table.ColHeader>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {optinData &&
                            optinData.map((obj, index) => (
                                <Table.Row key={index}>
                                    <Table.Col>{index + 1}</Table.Col>
                                    <Table.Col className="text-nowrap">{obj.mobileNumber}</Table.Col>
                                    {/* <Table.Col className="text-nowrap">
                                        {obj.status == "COMPLETED" && (
                                            <a href={obj.processedUri} target="_blank">
                                                Download
                                            </a>
                                        )}
                                    </Table.Col> */}
                                    <Table.Col className="text-nowrap">
                                        <Button onClick={() => handleUnblock(obj)} color="primary btn-block " className=" btn-block aligncentre" type="button">
                                            Unblock
                                        </Button>
                                    </Table.Col>
                                </Table.Row>
                            ))}
                    </Table.Body>
                </Table>
            </Card.Body>
        </Card>
    );
}

export default withRouter(ViewBlockedUsers);
